import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

const responseSchema = z.object({
	emirateId: z.number(),
	quotePlans: z.array(
		z.object({
			planId: z.number(),
			quoteResponseId: z.number(),
			quoteStatus: z.number(),
			quoteExpiryDate: z.string(),
			premiumAmount: z.number(),
			vatAmount: z.number(),
			quotePlanReferenceNumber: z.string(),
		})
	),
	policyTypeId: z.number(),
	totalInsuredLives: z.number(),
});

const getInSameQuoteList = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: 'admin/quote/:quoteReferenceNumber/quotes-list',
		method: 'GET',
		responseSchema,
		requestParameters: {
			quoteReferenceNumber: ['required', 'string'],
		},
	});

export default getInSameQuoteList;

export type GetInSameQuoteListResponse = TypeOfAPIResponse<ReturnType<typeof getInSameQuoteList>>;

export type GetInSameQuoteListError = TypeOfAPIError<ReturnType<typeof getInSameQuoteList>>;
